import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { start as startCookieBannerDetection } from "@eyeo-fragments/cookie-banner-detection/background";
import { start as startFilterExperiments } from "@eyeo-fragments/filter-experiments/background";
import { License } from "~/picreplacement/check";
import { initialize } from "~/alias/subscriptionInit";
import { Prefs } from "~/alias/prefs";
import { start as startSettings } from "~/prefs/background";
import * as logger from "~/utilities/background";
import { start as startInProductMessaging } from "../../ipm/background";
import { start as startNewTab } from "../../../adblock-betafish/new-tab/background";
import { start as startOnPageDialog } from "../../../adblock-betafish/onpage-dialog/background";
import { start as startTelemetry } from "../../telemetry/background";
import { start as startTestingEwe } from "../../testing/ewe/background";
async function bootstrapAsync() {
    try {
        startCookieBannerDetection();
        startTestingEwe();
        await Promise.all([
            startFilterExperiments(),
            startInProductMessaging(),
            startNewTab(),
            startOnPageDialog(),
            startTelemetry(),
        ]);
    }
    catch (ex) {
        logger.reportAndLogError(ex);
    }
}
function bootstrapSync() {
    if (Prefs.get("data_collection_opt_out")) {
        console.warn("Sentry is not initialized");
    }
    else {
        void ewe.sentry.start(webpackDotenvPlugin.SENTRY_DSN, webpackDotenvPlugin.SENTRY_ENVIRONMENT, info.addonVersion);
    }
    const onInstalledPromise = new Promise((resolve) => {
        browser.runtime.onInstalled.addListener((details) => {
            resolve(details);
        });
    });
    void Promise.all([onInstalledPromise, License.ready(), initialize]).then((detailsArray) => {
        if (detailsArray.length > 0 && detailsArray[0].reason) {
            License.enrollUser();
            if (detailsArray[0].reason === "install") {
                browser.alarms.create(License.sevenDayAlarmName, { delayInMinutes: 60 * 24 * 7 });
                License.addSevenDayAlarmStateListener();
                void browser.storage.local.set({ [License.sevenDayAlarmName]: true });
            }
        }
    });
}
async function bootstrap() {
    bootstrapSync();
    startSettings();
    await bootstrapAsync();
}
void bootstrap();
